import LogoL from './images/logo.png'
import Entrance from './images/backdrops/entrance.jpg'
import EntranceM from './images/backdrops/entranceP.jpg'
import LobbyL from './images/backdrops/lobby.jpg'
import Exhibition from './images/backdrops/exhibition-hall.jpg'
import Auditorium from './images/backdrops/auditorium.jpg'
import Countdown from './images/backdrops/countdown.jpg'
import CountdownP from './images/backdrops/countdownP.jpg'
import AuditoriumM from './images/backdrops/auditoriumP.jpg'
import MC from './images/backdrops/MC20.png'
import NetworkingL from './images/backdrops/networking.jpg'
import LobbyMusic from './images/audio/lobby.mp3'
import routes from './routes'
import Gallerium from './images/backdrops/gallerium.jpg'

const dev = {
  apiUrl: 'http://localhost:3000',
}

const prod = {
  apiUrl: 'https://nutricia2021.herokuapp.com',
}

const API_KEYS = {
  amplitude: 'e8843ed530bedae2e8cbaa72897e7d54',
}
const eventDays = []

const VOLUME_VALUE = 1

const config = process.env.NODE_ENV === 'production' ? prod : dev

const assets = {
  logo: {
    landscape: LogoL,
    portrait: LogoL,
  },
  entrance: {
    landscape: Entrance,
    portrait: EntranceM,
  },
  countdown: {
    landscape: Countdown,
    portrait: CountdownP,
  },
  lobby: {
    landscape: LobbyL,
    portrait: EntranceM,
  },
  auditorium1: {
    landscape: Auditorium,
    portrait: AuditoriumM,
  },
  auditorium2: MC,

  exhibition1: Exhibition,
  exhibition2: Exhibition,

  networking: {
    landscape: NetworkingL,
    portrait: NetworkingL,
  },
  gallerium: Gallerium,

  lobbyMusic: LobbyMusic,
}

const layout = {
  auditoriumVid: `
    top: 2%;
    bottom: 2%;
    left: 2.5%;
    right: 2%;
  `,
}

const lobbyEntries = [
  {
    id: 'auditorium',
    destination: routes.auditorium1,
    css: `
      top: 80%;
      left: 59.8%;
      right: 34%;
      bottom: 20.5%;
    `,
  },
  {
    id: 'helpdesk',
    destination: 0,
    css: `
      top: 74.5%;
      left: 11.5%;
      right: 85.5%;
      bottom: 25.5%;
    `,
  },
]

export default {
  API_KEYS,
  assets,
  layout,
  lobbyEntries,
  eventDays,
  VOLUME_VALUE,

  eventName: 'New Opportunities to Treat Cognitive Impairment Webinar',
  // googleAnalyticsID: 'UA-185128388-1',

  ...config,
}
